/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:42:21
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginCascader from 'bee-cascader';

require('bee-cascader/build/Cascader.css');

class Cascader extends Component {
	render() {
		return <OriginCascader {...this.props} />;
	}
}
export default Cascader;
